<template>
  <div>
    <div>
      <h1 class="text-4xl uppercase text-center pb-1.5 md:pb-3.5 md:pt-6">news</h1>
      <hr/>
      <div class="pt-11">
        <NuxtLink
            to="/news"
            class="
            font-bold
            text-darkRed
            pr-1.5
            underline underline-offset-1
            hover:text-darkBlu
          "
        >Back to News
        </NuxtLink
        >
        <template v-if="news">

          <NewsItem
              v-if="ready"
              :title="news.entry_title"
              :content="news.entry_content"
              :entryUri="news.entry_uri"
              :date="news.created_at"
              :album_path="news.album_path"
              :image_cached="news.image_cached"
              :image_name="news.image_name"
              class="box-link-news"
          />
        </template>
        <template v-else>
          <NewsLoader/>
        </template>
      </div>
    </div>
  </div>
</template>

<script setup>
import {http} from "~/utils/http";
import {useHead} from "nuxt/app";
import {computed, ref} from "vue";
import {Page} from "../../../composables/nhTypes";

const route = useRoute();
let uri = route.params.title;
const page = ref(new Page());

const ready = ref(false);
const news = ref(false);
const error = ref(false);
const status = ref(true);
const message = ref("");
useHead({
  title: computed(() =>  page.value.meta_title),
  meta: [
    {name: 'description', content:computed(() =>  page.value.meta_description)},
    {name: 'keywords', content: computed(() =>  page.value.meta_keywords)},
    { property: 'og:title', content: computed(() => page.value.meta_title) },
    { property: 'og:type', content: 'article' },
    { property: 'og:description', content: computed(() => page.value.meta_description) },
    { property: 'og:url', content:computed(() =>route.fullPath) },
  ],
})
const getEntry = async () => {
  try {
    await http.get("/api/news/" + uri).then((json) => {
      status.value = json.data.status;
      message.value = json.data.message;
      news.value = json.data.entry;
      page.value = json.data.meta_data;
      // page.value.meta_description.replace(/<\/?[^>]+>/ig, " ")
      ready.value = true;
    });
  } catch (e) {
    error.value = e.response.data.error;
  }
};

await getEntry();
</script>

<style>
.box-link-news a{
  word-break: break-all;
}
</style>
